import styled from "styled-components";

export const Inner = styled.div`
	display: flex;
	min-height: 500px;
	justify-content: space-between;
	align-items: center;
	flex-direction: column;
	padding: 30px 10px;
`;
